<template>
  <b-container fluid>
    <b-row>
      <b-col md="12">
        <iq-card>
          <template v-slot:headerTitle>
            <h4 class="
                  card-title
                  float-lefttitle-typography-color
                  title-typography-color
                ">
              <i class="fas fa-wallet"></i>
              {{ $t("public.views.Pages.Professional.Wallet.title") }}
              <span v-if="patient !== null && patient.name">
                - {{ patient.name }} {{ patient.lastname }} (
                {{ patient.document }} )
              </span>
            </h4>
          </template>
          <template v-slot:headerAction>
            <b-badge class="mr-2" variant="primary">{{ $t("public.views.Pages.Professional.Wallet.balance") }}
              {{ parseFloat(patient.walletBalance).toFixed(2) }}
            </b-badge>
            <b-button ref="btnShowNewVisit" class="mr-2" style="right" variant="success" @click="openModalCharge">{{
              $t("public.views.Pages.Professional.Wallet.btnCharge")
            }}
            </b-button>
            <b-button ref="btnShowNewVisit" class="mr-2" style="right" variant="danger" @click="openModalDischarge">{{
              $t("public.views.Pages.Professional.Wallet.btnDischarge")
            }}
            </b-button>
            <b-button v-if="patient !== null && patient.name" right variant="primary" @click="backContacts">{{
              $t("generic.btnBack")
            }}
            </b-button>
          </template>
          <template v-slot:body>
            <div class="text-right">
              <b-button class="mb-3 mr-1" variant="secondary" @click="getWalletTransactionsExcel">
                Excel
              </b-button>
            </div>
            <div>
              <v-data-table :footer-props="{
                showFirstLastPage: true,
                firstIcon: 'fas fa-arrow-left',
                lastIcon: 'fas fa-arrow-right',
                prevIcon: 'fas fa-minus',
                nextIcon: 'fas fa-plus',
                'items-per-page-options': [10, 25, 50],
              }" :headers="headers" :items="walletTransactions" :options.sync="pagination" :server-items-length="total"
                item-key="id">
                <template v-slot:item.date="{ item }">
                  <div v-if="item.date">
                    {{ item.date | adjustToTimezone("DD/MM/YYYY HH:mm") }}
                  </div>
                </template>
                <template v-slot:item.acto="{ item }">
                  <div v-if="item">
                    {{
                      $t(
                        "public.views.Pages.Professional.Wallet.type." +
                        item.type
                      )
                    }}
                  </div>
                </template>
                <template v-slot:item.payment="{ item }">
                  <div v-if="item.payment.paymentStatus">
                    {{
                      $t(
                        "public.views.Pages.Professional.Wallet.status." +
                        item.payment.paymentStatus
                      )
                    }}
                  </div>
                </template>
                <template v-slot:item.user="{ item }">
                  <b-list-group-item v-if="item.professionalCharge" class="d-flex align-items-center border-0 p-0">
                    <span class="w-25">{{
                      $t("public.views.Pages.Patient.Wallet.professional")
                    }}:</span>
                    <b-avatar v-bind:src="
                      item.professionalCharge.avatarUrl
                        ? item.professionalCharge.avatarUrl +
                        '/' +
                        getAuthentication()
                        : ''
                    "></b-avatar>
                    <div class="media-support-info ml-3">
                      <p class="mb-0 font-size-16">
                        {{ item.professionalCharge.name }}
                      </p>
                      <p class="mb-0 font-size-12">
                        {{ item.professionalCharge.lastname }}
                      </p>
                    </div>
                  </b-list-group-item>
                  <b-list-group-item v-else class="d-flex align-items-center border-0 p-0">
                    <span class="w-25">{{
                      $t("public.views.Pages.Patient.Wallet.patient1")
                    }}:</span>
                    <b-avatar v-bind:src="
                      item.patient.avatarUrl
                        ? item.patient.avatarUrl +
                        '/' +
                        getAuthentication()
                        : ''
                    "></b-avatar>
                    <div class="media-support-info ml-3">
                      <p class="mb-0 font-size-16">{{ item.patient.name }}</p>
                      <p class="mb-0 font-size-12">
                        {{ item.patient.lastname }}
                      </p>
                    </div>
                  </b-list-group-item>
                </template>
                <template v-slot:item.event="{ item }">
                  <div v-if="item.event">
                    {{ item.event.startedAt | adjustToTimezone("DD/MM/YYYY HH:mm") }}
                  </div>
                </template>
                <template v-slot:item.cashFlow="{ item }">
                  <div v-if="item.cashFlow">
                    <b-badge v-if="
                      item.type === 'CHARGE_PROFESSIONAL' ||
                      item.type === 'CHARGE' ||
                      item.type === 'EVENT_CANCEL'
                    " variant="success">{{ parseFloat(item.cashFlow).toFixed(2) }} €
                    </b-badge>
                    <b-badge v-else variant="danger">{{ parseFloat(item.cashFlow).toFixed(2) }} €
                    </b-badge>
                  </div>
                </template>
                <template v-slot:item.actions="{ item }">
                  <div class="div-table-data">
                    <button :id="'btnDetails' + item.id" class="item" v-on:click="showDetails(item.event, item.comments)">
                      <i class="ri-file-paper-line"></i>
                    </button>
                    <b-popover :target="'btnDetails' + item.id" placement="botton" triggers="hover focus">
                      <template #title>{{
                        $t("public.views.Pages.Professional.Wallet.btnDetails")
                      }}
                      </template>
                    </b-popover>
                    <button :id="'btnUpdate' + item.id" class="item" v-on:click="
                      showUpdateDetails(item.event, item.comments, item.id)
                    ">
                      <i class="ri-pencil-line"></i>
                    </button>
                    <b-popover :target="'btnUpdate' + item.id" placement="botton" triggers="hover focus">
                      <template #title>{{
                        $t(
                          "public.views.Pages.Professional.Wallet.modalDatails.btnUpdate"
                        )
                      }}
                      </template>
                    </b-popover>
                  </div>
                </template>
              </v-data-table>
            </div>
          </template>
        </iq-card>
      </b-col>
    </b-row>
    <b-modal id="modal-details" :hide-footer="actionWalletTransaction !== 'UPDATE'" centered
      @ok="updateTransactionsWallet">
      <template #modal-title>{{
        $t("public.views.Pages.Professional.Wallet.modalDatails.title")
      }}
      </template>
      <template #modal-cancel>{{
        $t("public.views.Pages.Professional.Wallet.modalDatails.btnCancel")
      }}
      </template>
      <template #modal-ok>{{
        $t("public.views.Pages.Professional.Wallet.modalDatails.btnUpdate")
      }}
      </template>
      <b-form-group label-for="comments">
        <template slot="label">{{
          $t("public.views.Pages.Professional.Wallet.modalDatails.comments")
        }}:
        </template>
        <b-form-textarea v-model="details.comments" :disabled="actionWalletTransaction !== 'UPDATE'" max-rows="6"
          rows="3"></b-form-textarea>
      </b-form-group>
      <div v-if="detailsEvent">
        <b-form-group label-for="patients">
          <template slot="label">{{
            $t(
              "public.views.Pages.Professional.Wallet.modalDatails.patients"
            )
          }}:
          </template>
          <b-input v-model="details.patients" :disabled="true" type="text"></b-input>
        </b-form-group>
        <b-form-group label-for="professionals">
          <template slot="label">{{
            $t(
              "public.views.Pages.Professional.Wallet.modalDatails.professionals"
            )
          }}:
          </template>
          <b-input v-model="details.professionals" :disabled="true" type="text"></b-input>
        </b-form-group>
        <b-form-group label-for="visitType">
          <template slot="label">{{
            $t(
              "public.views.Pages.Professional.Wallet.modalDatails.visitType"
            )
          }}:
          </template>
          <b-input v-model="details.visitType" :disabled="true" type="text"></b-input>
        </b-form-group>
        <b-form-group label-for="date">
          <template slot="label">{{
            $t("public.views.Pages.Professional.Wallet.modalDatails.date")
          }}:
          </template>
          <b-input v-model="details.date" :disabled="true" type="text"></b-input>
        </b-form-group>
      </div>
    </b-modal>
    <b-modal id="modal-charge" centered @ok="payCash">
      <template #modal-title>
        <div v-if="action === 'CHARGE'">
          {{ $t("public.views.Pages.Professional.Wallet.modalCharge.title") }}
        </div>
        <div v-if="action === 'DISCHARGE'">
          {{
            $t(
              "public.views.Pages.Professional.Wallet.modalCharge.titleDischarge"
            )
          }}
        </div>
      </template>
      <template #modal-cancel>{{
        $t("public.views.Pages.Professional.Wallet.modalCharge.btnCancel")
      }}
      </template>
      <template #modal-ok>
        <div v-if="action === 'CHARGE'">
          {{ $t("public.views.Pages.Professional.Wallet.modalCharge.btnSave") }}
        </div>
        <div v-if="action === 'DISCHARGE'">
          {{
            $t(
              "public.views.Pages.Professional.Wallet.modalCharge.btnSaveDischarge"
            )
          }}
        </div>
      </template>

      <b-form-group label-for="charge">
        <template v-if="action === 'CHARGE'" slot="label">{{
          $t("public.views.Pages.Professional.Wallet.modalCharge.charge")
        }}
        </template>
        <template v-else-if="action === 'DISCHARGE'" slot="label">{{
          $t("public.views.Pages.Professional.Wallet.modalCharge.discharge")
        }}
        </template>
        <vue-numeric v-model="charge" :class="{
          'text-danger': isFormChargeErrors,
          'is-invalid': isFormChargeErrors,
        }" :max="10000" :min="1" :precision="2" currency="€" separator="."></vue-numeric>
        <ul v-if="isFormChargeErrors">
          <li v-for="(error, index) in validator.getErrors('charge')" v-bind:key="index" class="form-text text-danger">
            &nbsp;{{ error }}
          </li>
        </ul>
      </b-form-group>
      <b-form-group label-for="comments">
        <template slot="label">{{
          $t("public.views.Pages.Professional.Wallet.modalCharge.comments")
        }}
        </template>
        <b-form-textarea id="comments" v-model="comments" max-rows="6" rows="3"></b-form-textarea>
      </b-form-group>
    </b-modal>
    <notifications group="notificacions" />
  </b-container>
</template>
<script>
import routes from "../../../router/index";

import { mapActions, mapGetters } from "vuex";

import { xray } from "../../../config/pluginInit";
import { StripeCheckout } from "@vue-stripe/vue-stripe";
import validator from "vue-m-validator";

import walletService from "../../../services/wallet";
import utilsService from "../../../services/utils";
import userService from "../../../services/user";
import patientService from "../../../services/patient";

export default {
  name: "WalletProfessional",
  mounted() {
    xray.index();
    this.getUser();
    this.getPatient(this.$route.query.patient);
    this.getAllWalletTransactions(this.$route.query.patient);
    utilsService.auditActivity({ action: "VIEW", module: "PROFESSIONAL_WALLET", info: "" });
  },
  watch: {
    pagination: {
      handler() {
        if (this.start) {
          this.getAllWalletTransactions(this.$route.query.patient);
        }
        this.start = true;
      },
    },
  },
  methods: {
    getAuthentication() {
      return localStorage.getItem('authorization');
    },
    async getPatient(id) {
      let self = this;

      this.$awn.asyncBlock(
        patientService.get(id),
        (response) => {
          self.patient = response.data;

          self.walletBalance = response.data.walletBalance;
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "patientService.get",
            module: "view-pages-professional-wallet",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              id: id
            })
          });
        },
        " "
      );
    },
    getWalletTransactionsExcel() {
      var objectUrl =
        process.env.VUE_APP_BASE_URL_CORE +
        "auth/wallet/" +
        this.patient.walletId +
        "/transactions/excel?token=" +
        localStorage.getItem("authorization");
      window.open(objectUrl);
    },
    showUpdateDetails(event, comments, idTransactionWallet) {
      this.actionWalletTransaction = "UPDATE";
      if (event) {
        this.detailsEvent = true;
        let patients = "";
        event.patients.forEach(function (item) {
          patients = patients + item.name + " " + item.lastname;
        });

        let professionals = "";
        event.professionals.forEach(function (item) {
          professionals = professionals + item.name + " " + item.lastname;
        });

        this.details = {
          id: idTransactionWallet,
          comments: comments,
          patients: patients,
          professionals: professionals,
          visitType: event.visitType.name,
          date: new Date(event.startedAt).toLocaleString(),
        };
      } else {
        this.detailsEvent = false;
        this.details = {
          id: idTransactionWallet,
          comments: comments,
        };
      }

      this.$bvModal.show("modal-details");
    },
    showDetails(event, comments) {
      this.actionWalletTransaction = "CREATE";
      if (event) {
        this.detailsEvent = true;
        let patients = "";
        event.patients.forEach(function (item) {
          patients = patients + item.name + " " + item.lastname;
        });

        let professionals = "";
        event.professionals.forEach(function (item) {
          professionals = professionals + item.name + " " + item.lastname;
        });

        this.details = {
          comments: comments,
          patients: patients,
          professionals: professionals,
          visitType: event.visitType.name,
          date: new Date(event.startedAt).toLocaleString(),
        };
      } else {
        this.detailsEvent = false;
        this.details = {
          comments: comments,
        };
      }

      this.$bvModal.show("modal-details");
    },
    backContacts() {
      var filter = "";
      var status = "";

      if (this.$route.query.queryFilterBack !== undefined) {
        filter = this.$route.query.queryFilterBack;
      }

      if (this.$route.query.queryStatusBack !== undefined) {
        status = this.$route.query.queryStatusBack;
      }

      this.$router.push({
        name: "auth.professional.contact.contacts",
        query: {
          queryFilter: filter,
          queryStatus: status,
        },
      });
    },
    // Modal validator
    checkCharge(_charge) {
      const CHARGE = _charge.trim();
      const RULE_1 = {
        expression: !CHARGE || CHARGE === "",
        name: "name",
        msg: this.$i18n.t(
          "public.views.Pages.Professional.Wallet.modalCharge.errors.charge"
        ),
      };
      const RULE_2 = {
        expression: CHARGE === "0",
        name: "name",
        msg: this.$i18n.t(
          "public.views.Pages.Professional.Wallet.modalCharge.errors.chargeEqualsZero"
        ),
      };
      validator.addRule(RULE_1).addRule(RULE_2);
      this.notFirst();
    },
    notFirst() {
      this.isFirstRun = false;
    },
    checkFormCharge() {
      this.checkCharge(this.charge);
    },
    // List
    async getUser() {
      let self = this;
      userService
        .get(localStorage.getItem("userId"))
        .then((response) => {
          if (response) {
            self.user = response.data;
          }
        })
        .catch(function (error) {
          if (error.response && error.response.status === 404) {
            routes.push({ name: "public.signin" });
          } else if (error.response && error.response.status === 500) {
            routes.push({ name: "public.signin" });
          } else {
            routes.push({ name: "public.signin" });
          }
        });
    },
    getAllWalletTransactions(patientId) {
      let self = this;

      this.$awn.asyncBlock(
        patientService.getAllTransactionsWallet(
          this.pagination.page - 1,
          this.pagination.itemsPerPage,
          patientId
        ),
        (response) => {
          if (response) {
            self.walletTransactions = response.data.content;
            self.total = response.data.pageable.total;
          }
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "patientService.getAllTransactionsWallet",
            module: "view-pages-professional-wallet",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              page: this.pagination.page - 1,
              itemsPerPage: this.pagination.itemsPerPage,
              patientId: patientId
            })
          });
        },
        " "
      );
    },
    // Charge
    openModalCharge() {
      this.action = "CHARGE";
      this.clearModal();
      this.$bvModal.show("modal-charge");
    },
    openModalDischarge() {
      this.action = "DISCHARGE";
      this.clearModal();
      this.$bvModal.show("modal-charge");
    },
    clearModal() {
      this.charge = 1.0;
      this.comments = "";
    },
    updateTransactionsWallet() {
      let self = this;

      let data = {
        comments: this.details.comments,
      };

      this.$awn.asyncBlock(
        patientService.updateTransactionsWallet(
          this.patient.id,
          this.details.id,
          data
        ),
        (response) => {
          utilsService.auditActivity({ action: "UPDATE", module: "PROFESSIONAL_WALLET", info: "" });
          self.getAllWalletTransactions(self.patient.id);
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "patientService.updateTransactionsWallet",
            module: "view-pages-professional-wallet",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              patientId: this.patient.id,
              detailsId: this.details.id,
              data: data
            })
          });
        },
        " "
      );
    },
    payCash() {
      let self = this;

      let type = "CHARGE_PROFESSIONAL";

      if (this.action === "DISCHARGE") {
        type = "DICHARGE_PROFESSIONAL";
      }

      let data = {
        type: type,
        charge: this.charge,
        patientId: this.patient.id,
        comments: this.comments,
      };

      this.$awn.asyncBlock(
        walletService.payCash(this.patient.walletId, data),
        (response) => {
          utilsService.auditActivity({ action: "UPDATE", module: "PROFESSIONAL_WALLET", info: "" });
          self.getAllWalletTransactions(self.patient.id);
          if (self.$route.query.patient) {
            self.getPatient(self.$route.query.patient);
          }
          this.$notify({
            group: "notificacions",
            title: this.$i18n.t(
              "public.views.Pages.Professional.Wallet.modalCharge.success.notify.title"
            ),
            text: this.$i18n.t(
              "public.views.Pages.Professional.Wallet.modalCharge.success.notify.text"
            ),
            type: "success",
          });
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "walletService.payCash",
            module: "view-pages-professional-wallet",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              walletId: this.patient.walletId, data: data
            })
          });
        },
        " "
      );
    },
    getPatient(id) {
      let self = this;

      this.$awn.asyncBlock(
        patientService.get(id),
        (response) => {
          if (response) {
            self.patient = response.data;
          }
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "patientService.get",
            module: "view-pages-professional-wallet",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              id: id
            })
          });
        }
      );
    },
  },
  computed: {
    //Validate form
    isDisabled() {
      return this.isFirstRun === true || this.validator.errors.length > 0;
    },
    isFormChargeErrors() {
      let errors = this.validator.getErrors("charge");
      return errors && errors.length > 0;
    },
    ...mapGetters({
      selectedUser: "Setting/userState",
    }),
  },
  data() {
    return {
      start: false,
      total: 0,
      pagination: { page: 1, itemsPerPage: 10 },
      action: "",
      actionWalletTransaction: "",
      //Global
      user: {},
      detailsEvent: "",
      details: {},
      validator: validator,
      isFirstRun: true,
      isValidate: false,
      searchPatient: true,
      //Modal charge
      walletId: "",
      charge: 1.0,
      comments: "",
      professionalId: "",
      walletBalance: "",
      //Table transactions

      headers: [
        {
          text: this.$i18n.t(
            "public.views.Pages.Professional.Wallet.headers.date"
          ),
          align: "start",
          value: "date",
        },
        {
          text: this.$i18n.t(
            "public.views.Pages.Professional.Wallet.headers.acto"
          ),
          value: "acto",
        },
        {
          text: this.$i18n.t(
            "public.views.Pages.Professional.Wallet.headers.user"
          ),
          value: "user",
        },
        {
          text: this.$i18n.t(
            "public.views.Pages.Professional.Wallet.headers.event"
          ),
          value: "event",
        },
        {
          text: this.$i18n.t(
            "public.views.Pages.Professional.Wallet.headers.cashFlow"
          ),
          value: "cashFlow",
        },
        {
          text: "",
          value: "actions",
        },
      ],
      patient: {},
      walletTransactions: [],
    };
  },
  components: {
    StripeCheckout,
  },
};
</script>
